import { Component, inject } from '@angular/core';
import { ApiService } from 'src/app/ushers/service/api.service';
import { environment } from 'src/environments/environment.development';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/ushers/service/auth.service';
import { HttpResponse } from '@angular/common/http';
import { LayoutService } from 'src/app/layout/service/app.layout.service';

@Component({
    templateUrl: './login2.component.html',
})
export class Login2Component {
    loading = false;
    failed = false;
    passwordHidden: boolean = true;

    rememberMe: boolean = false;
    apiService = inject(ApiService);
    authService = inject(AuthService);
    layoutService = inject(LayoutService);
    obj: any = {};

    show() {
        this.passwordHidden = !this.passwordHidden;
    }

    login() {

        this.loading = true;
        this.failed = false;

        if (environment.autheticatonType == 'response') {
            firstValueFrom(this.apiService.post(`${environment.api.auth}/authenticate-admin`, this.obj)).
                then(res => {
                    this.authService.setUser(res)
                    setTimeout(() => {
                        location.reload();
                        this.loading = false;
                    }, 1000)
                }).catch(err => {
                    this.loading = false;
                    this.failed = true;
                    console.log(err);
                })
        }

        if (environment.autheticatonType == 'btoa') {
            // Encode email and password for authentication
            const encodedCredentials = btoa(this.obj.email + ":" + this.obj.password);

            // Call authentication endpoint
            this.apiService.login(`${environment.api.auth}/authenticate-admin`, encodedCredentials)
                .subscribe(
                    {
                       
                        error: () => {  
                            this.loading = false;
                            this.failed = true;
                        },    // errorHandler 
                        next: (res: HttpResponse<any>) => { 
                            if (res.status === 200) {
                                // Set user details in the application
                                console.log(res)
                                res.body.token = res.headers.get('Authorization')
                                this.authService.setUser(res.body);
                                
                                
                            }else{
                                this.loading = false;
                                this.failed = true;
                            }
                         },     // nextHandler
                         complete: () => { 
                            setTimeout(() => {
                                location.reload();
                                this.loading = false;
                            }, 1000);
                         }, // completeHandler
                    }
                );

        }

    }


}
